import React from "react";
import { LOGISTICS_EXTRA_FLOW_CONFIGS } from "./logisticsProcessFlowExtra";

const FLOW_CONFIGS = LOGISTICS_EXTRA_FLOW_CONFIGS;
const STEP_COUNT = 6;

const styles = `
  .log-diag {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #dbe7f7;
    font-family: Roboto, sans-serif;
  }
  .log-diag-head {
    background: #1d3f7d;
    padding: 14px 16px 12px;
    text-align: center;
  }
  .log-diag-head h4 {
    font-family: Exo, sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0 0 4px;
    line-height: 1.25;
  }
  .log-diag-head p {
    margin: 0;
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    line-height: 1.4;
  }
  .log-diag-hitl {
    background: #f4f7fb;
    padding: 10px 12px 6px;
    border-bottom: 1px solid #e2eaf4;
  }
  .log-diag-hitl-label {
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 700;
    color: #c45d1e;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: center;
    margin: 0 0 8px;
  }
  .log-diag-hitl-row,
  .log-diag-body {
    display: grid;
    grid-template-columns: 108px repeat(${STEP_COUNT}, minmax(0, 1fr)) 108px;
    gap: 4px;
    min-width: 0;
  }
  .log-diag-hitl-pill {
    grid-column: span 2;
    background: linear-gradient(180deg, #f5a84c 0%, #e8913a 100%);
    color: #fff;
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 600;
    text-align: center;
    padding: 6px 4px;
    border-radius: 6px;
    line-height: 1.25;
    box-shadow: 0 2px 4px rgba(232, 145, 58, 0.3);
  }
  .log-diag-io {
    background: #f0f6fc;
    border: 1px solid #d4e3f5;
    border-radius: 6px;
    padding: 8px 8px 10px;
    align-self: stretch;
  }
  .log-diag-io h5 {
    font-family: Exo, sans-serif;
    font-size: 9px;
    font-weight: 700;
    color: #1d3f7d;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    margin: 0 0 6px;
    text-align: center;
  }
  .log-diag-io ul {
    margin: 0;
    padding: 0 0 0 14px;
    font-size: 8px;
    color: #3a4d62;
    line-height: 1.45;
  }
  .log-diag-step {
    background: linear-gradient(180deg, #ffffff 0%, #f7fbff 100%);
    border: 1px solid #d4e3f5;
    border-radius: 6px;
    padding: 6px 5px 5px;
    display: flex;
    flex-direction: column;
    min-height: 118px;
  }
  .log-diag-step-head {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 4px;
  }
  .log-diag-step-num {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #1d3f7d;
    color: #fff;
    font-size: 8px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .log-diag-step-title {
    font-family: Exo, sans-serif;
    font-size: 8px;
    font-weight: 700;
    color: #1d3f7d;
    line-height: 1.2;
  }
  .log-diag-step-icon {
    text-align: center;
    color: #27baa7;
    font-size: 16px;
    margin: 2px 0 4px;
  }
  .log-diag-step-tasks {
    margin: 0 0 auto;
    padding: 0 0 0 10px;
    font-size: 7px;
    color: #4a5d72;
    line-height: 1.35;
    flex: 1;
  }
  .log-diag-step-agent {
    margin-top: 4px;
    padding-top: 4px;
    border-top: 1px dashed #d4e3f5;
    text-align: center;
  }
  .log-diag-step-agent strong {
    display: block;
    font-size: 7px;
    color: #1d3f7d;
    line-height: 1.2;
  }
  .log-diag-step-agent span {
    font-size: 6px;
    color: #27baa7;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .log-diag-systems {
    background: #1d3f7d;
    padding: 8px 12px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    justify-content: center;
  }
  .log-diag-systems span {
    font-family: Exo, sans-serif;
    font-size: 8px;
    font-weight: 600;
    color: #1d3f7d;
    background: #fff;
    border-radius: 4px;
    padding: 3px 8px;
  }
  .log-diag-systems p {
    margin: 0;
    font-size: 8px;
    color: rgba(255, 255, 255, 0.8);
    line-height: 1.4;
  }
  .log-diag-scroll {
    overflow-x: auto;
    scrollbar-width: thin;
  }
  @media (max-width: 900px) {
    .log-diag-hitl-row,
    .log-diag-body {
      min-width: 760px;
    }
  }
`;

function CheckpointPill({ label, startCol }) {
  return (
    <div className="log-diag-hitl-pill" style={{ gridColumn: `${startCol} / span 2` }}>
      {label}
    </div>
  );
}

export default function LogisticsProcessFlow({ useCaseId }) {
  const config = FLOW_CONFIGS[useCaseId];
  if (!config) return null;

  return (
    <div className="log-diag" role="img" aria-label={config.title}>
      <style>{styles}</style>

      <header className="log-diag-head">
        <h4>{config.title}</h4>
        <p>{config.subtitle}</p>
      </header>

      <div className="log-diag-scroll">
        {config.checkpoints.length > 0 && (
          <div className="log-diag-hitl">
            <p className="log-diag-hitl-label">Human-in-the-loop checkpoints</p>
            <div className="log-diag-hitl-row">
              {config.checkpoints.map((cp) => (
                <CheckpointPill key={cp.label} label={cp.label} startCol={cp.startCol} />
              ))}
            </div>
          </div>
        )}

        <div className="log-diag-body">
          <aside className="log-diag-io" aria-label="Inputs">
            <h5>Inputs</h5>
            <ul>
              {config.inputs.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </aside>

          {config.steps.map((step) => {
            const Icon = step.icon;
            return (
              <div key={step.id} className="log-diag-step">
                <div className="log-diag-step-head">
                  <span className="log-diag-step-num">{step.id}</span>
                  <span className="log-diag-step-title">{step.title}</span>
                </div>
                <div className="log-diag-step-icon" aria-hidden="true">
                  <Icon />
                </div>
                <ul className="log-diag-step-tasks">
                  {step.tasks.map((task) => (
                    <li key={task}>{task}</li>
                  ))}
                </ul>
                <footer className="log-diag-step-agent">
                  <strong>{step.agent}</strong>
                  <span>{step.agentRole}</span>
                </footer>
              </div>
            );
          })}

          <aside className="log-diag-io" aria-label="Outputs">
            <h5>Outputs</h5>
            <ul>
              {config.outputs.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </aside>
        </div>
      </div>

      <footer className="log-diag-systems">
        <p>Systems:</p>
        {config.systems.map((system) => (
          <span key={system}>{system}</span>
        ))}
      </footer>
    </div>
  );
}

